<template>
  <div id="BlogDetail">
    <div class="banner">
      <img src="/static/images/blog/blog_bg.png" alt="">
      <div class="bannerText">
        <div class="title">{{$t("blog.bannerText")}}</div>
        <div class="titleSub">{{$t("blog.bannerDetail")}}</div>
      </div>
    </div>
    <div class="content">
        <div class="con">
          <div class="blogList" v-for="(item,index) in blogList" :key="index" :class="index==selectId?'active':''" @mouseover="blogItemShow(index)" @mouseleave="blogItemHidden(index)">
            <div class="imgBox">
              <img :src="item.src" alt="">
            </div>
            <div class="conText">
                <div class="title">{{item.title}}</div>
                <div class="detail">
                  <p>{{item.detail}}</p>
                </div>
                <div class="time">{{item.time}}</div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectId:null,
      blogList:[
        {
          title:'LAN Kitchen printer 80mm',
          src:'/static/images/blog/blog_a.png',
          detail:' We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible.  We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible.',
          time:'06-19 /2019'
        },
      ],
      pages:11
    };
  },
  //定义这个sweiper对象
  computed: {},
  created:function () {
    window.scroll(0, 0);
    this.$emit('menuHiddens');
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {
    blogItemShow(id){
      this.selectId = id
    },
    blogItemHidden(id){
      this.selectId = null
    },
    changePage(el){
      console.log(el)
    }
  }
};
</script>
<style lang="less" type="text/less">
  .el-pagination {
    text-align: center;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #333;
    color: #FFF;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover{
    color: #333;
  }
  .el-pagination.is-background .el-pager li.active:hover{
    color: #FFF;
  }
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
    color: #999;
  }
</style>
<style scoped lang="less" type="text/less">
#BlogDetail{
  margin-top: 65px;
  .banner{
    position: relative;
    img{
      width: 100%;
    }
    .bannerText{
      position:absolute;
      top: 40%;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      .title{
        font-size: 40px;
        font-weight: bold;
        position: relative;
        padding-right: 40px;
        &::before{
          content:'';
          display: inline-block;
          height: 38px;
          width: 3px;
          background: #e2e2e2;
          position: absolute;
          right: 0;
          bottom: 7px;
        }
      }
      .titleSub{
        padding-left: 30px;
        font-size: 20px;
        max-width: 600px;
      }
    }
  }
  .content{
    padding: 60px 0;
    .con{
      width: 60%;
      margin: 0 auto;
      .blogList{
        position: relative;
        margin-bottom: 65px;
        .imgBox{

        }
        .conText{
          padding: 20px 0;
          .title{
            font-size: 20px;
            font-weight:bold;
            color: #333;
          }
          .detail{
            font-size: 14px;
            padding: 10px 0;
            color: #666;
          }
          .time{
            font-size: 13px;
          }
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Blog/BlogDetail.vue